import { useActivityFeedbackView } from '@/libs/fleet-api/services/robotic';
import { Button, Descriptions, Modal, Spin, Typography } from 'antd';
import { FC } from 'react';

type Props = {
	open: boolean;
	activityDetailId: number | null;
	onClose: () => void;
};

const ViewDetailModal: FC<Props> = ({ open, activityDetailId, onClose }) => {
	const feedbackViewQuery = useActivityFeedbackView({
		roboticActivityId: open ? activityDetailId : null,
	});

	const data = feedbackViewQuery.data?.data;
	const isFetching = feedbackViewQuery.isFetching;

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={null}
			title="Detail Feedback"
			width={560}
		>
			{isFetching ? (
				<div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
					<Spin />
				</div>
			) : (
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<Descriptions bordered size="small" column={1}>
						<Descriptions.Item label="Pending Step">
							{data?.pendingStep ?? '-'}
						</Descriptions.Item>
						<Descriptions.Item label="Pending Field">
							{data?.pendingField ?? '-'}
						</Descriptions.Item>
						<Descriptions.Item label="Pending Message">
							<Typography.Text style={{ color: 'red' }}>
								{data?.pendingMessage ?? '-'}
							</Typography.Text>
						</Descriptions.Item>
					</Descriptions>

					<div
						style={{
							border: '1px solid #d9d9d9',
							borderRadius: 4,
							minHeight: 200,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							background: '#fafafa',
							overflow: 'hidden',
						}}
					>
						{data?.pendingImage?.url ? (
							<img
								src={data.pendingImage.url}
								alt={data.pendingImage.name ?? 'Screenshot'}
								style={{ maxWidth: '100%', maxHeight: 400, objectFit: 'contain' }}
							/>
						) : (
							<Typography.Text type="secondary">Tidak ada screenshot</Typography.Text>
						)}
					</div>

					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button onClick={onClose}>Kembali</Button>
					</div>
				</div>
			)}
		</Modal>
	);
};

export default ViewDetailModal;
